function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { DefaultText } from './Paragraph';
const ValidationSummary = _ref => {
  let {
    errorMessage,
    ...rest
  } = _ref;
  const theme = useTheme();
  if (!errorMessage) {
    return null;
  }
  return /*#__PURE__*/React.createElement(DefaultText, _extends({
    margin: 4,
    textAlign: "justify",
    color: theme.palette.error.main
  }, rest), errorMessage);
};
export { ValidationSummary };